import { useQuery } from '@tanstack/react-query'
import { chatApi } from '../../api/chat.api'

/** Summe aller ungelesenen Chat-Nachrichten über alle Channels — für das rote Badge am
 * Chat-Menüpunkt in Sidebar/BottomNav. Teilt sich den Query-Key mit useChatSession/
 * FloatingChatWidget, daher ein gemeinsamer Cache statt doppelter Requests. */
export function useChatUnreadTotal(enabled = true): number {
  const { data } = useQuery({
    queryKey: ['chat', 'unread-counts'],
    queryFn: async () => (await chatApi.unreadCounts()).data,
    refetchInterval: 20_000,
    enabled,
  })
  return Object.values(data ?? {}).reduce((sum, n) => sum + n, 0)
}
